<template>
  <section
    class="page flex flex-col items-center h-full relative !px-0"
    data-page-id="cover"
  >
    <div class="flex flex-col items-center justify-between w-full h-full">
      <div class="flex flex-col px-[20mm] test">
        <AppImgPlaceholder
          :src="pdfData.logo"
          class="!h-[33mm] w-fit ml-auto aspect-square mb-6"
        />

        <h1 class="text-[50pt] font-bold leading-[1] text-black max-w-[72%] mb-6">
          {{ pdfData.municipality.name }}
        </h1>

        <h2 class="text-[33pt] text-black font-semibold mb-0">
          Integrated Development Plan
        </h2>

        <h2 class="text-[33pt] text-black font-semibold">
          {{ pdfData.duration }}
        </h2>

        <h3 class="text-[20pt] text-black font-medium my-4">
          {{ pdfData.subtitle }}
        </h3>

        <span class="text-[11pt] text-black mb-12">
          Last Published: {{ dateFormatter.formatShortDate(pdfData.lastPublishedAt) || 'N/A' }}
        </span>
      </div>

      <div class="w-full flex-1 max-h-[100mm]">
        <div class="flex w-full relative z-[1] h-[3mm]">
          <div
            v-for="color in ['bg-black', 'bg-green-700', 'bg-orange-700', 'bg-blue-700', 'bg-yellow-400']"
            :key="color"
            :class="color"
            class="h-full flex-1"
          />
        </div>

        <AppImgPlaceholder
          :src="pdfData.coverPageImage"
          class="w-full [&_img]:object-cover h-[97mm]"
        />
      </div>
    </div>

    <!--static reuseable elements-->
    <div class="!h-0 overflow-hidden hidden relative">
      <div class="header-left h-full !flex items-end">
        <img
          :src="pdfData.logo"
          class="h-[24mm] w-fit aspect-square"
        >
      </div>

      <div class="footer h-full">
        <div class="flex items-center justify-between border-t pt-1 pb-8 border-black w-full relative top-full -translate-y-full">
          <span class="footer-left max-w-[70%] flex-0 font-semibold text-black text-[13px] whitespace-prewrap inline-block h-fit tracking-tight">
            {{ pdfData.municipality.name }} Living Municipal IDP {{ pdfData.duration }}&nbsp;&nbsp;
          </span>

          <div class="footer-right !flex items-center text-end">
            <img
              :src="LivingPlansLogoText"
              class="h-5"
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import LivingPlansLogoText from '@/assets/images/logos/living-plans-logo-single-line.svg';
import { AppImgPlaceholder } from '@/components/app';

import { useDateFormatter } from '@/composables';

const dateFormatter = useDateFormatter();

defineProps({
  pdfData: {
    type: Object,
    required: true,
  },
});
</script>
